// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notificationitem_notification__FVdmL","error":"Notificationitem_error__1reLm","closeButton":"Notificationitem_closeButton__35XfQ"};